<template>
  <div class="flex justify-between flex-wrap mw-100">
    <div v-show="artist" class="artist-data w-100">
      <h2 class="artist-info f7 f5-ns fw6 lh-title mv0" :class="{'light-silver' : isFirstArtist || isPodium, 'accent': inHome}">{{ artist.name }} </h2>
      <h3 class="artist-info f7 fw4 mt0 mb0 textColor" :class="{'light-silver' : isFirstArtist || isPodium }">{{ artist.phrase }}</h3>
    </div>
  </div>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

  export default {
    name: 'artist-data',
    props: {
      artist: {
        required: true
      },
      isFirstArtist: {
        default: false
      },
      isPodium: {
        default: false
      },
      inHome: {
        default: false
      }
    },
    components: {
      FontAwesomeIcon
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .artist-data {
    margin-left: 10px;
  }

  .artist-info {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/ArtistData.vue